import React, { memo, SVGProps } from 'react'

export const Trash = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M19.7789 4.57824H12.72V3.44064C12.72 3.0432 12.3974 2.72064 12 2.72064C11.6026 2.72064 11.28 3.0432 11.28 3.44064V4.57824H4.22113C3.82369 4.57824 3.50113 4.9008 3.50113 5.29824C3.50113 5.69568 3.82369 6.01824 4.22113 6.01824H4.72993L5.50561 18.1498C5.59297 19.5053 6.72481 20.567 8.08225 20.567H15.9178C17.2752 20.567 18.407 19.5062 18.4944 18.1498L19.2701 6.01824H19.7789C20.1763 6.01824 20.4989 5.69568 20.4989 5.29824C20.4989 4.9008 20.1763 4.57824 19.7789 4.57824ZM17.0573 18.0576C17.0189 18.6566 16.5187 19.1261 15.9178 19.1261H8.08225C7.48225 19.1261 6.98209 18.6566 6.94273 18.0576L6.17281 6.01824H17.8272L17.0573 18.0576Z"
      fill="currentColor"
    />
    <path
      d="M10.1386 8.53728C9.74113 8.53728 9.41857 8.85984 9.41857 9.25728V15.887C9.41857 16.2845 9.74113 16.607 10.1386 16.607C10.536 16.607 10.8586 16.2845 10.8586 15.887V9.25728C10.8586 8.85984 10.536 8.53728 10.1386 8.53728Z"
      fill="currentColor"
    />
    <path
      d="M13.8614 16.607C14.2589 16.607 14.5814 16.2845 14.5814 15.887V9.25728C14.5814 8.85984 14.2589 8.53728 13.8614 8.53728C13.464 8.53728 13.1414 8.85984 13.1414 9.25728V15.887C13.1414 16.2845 13.464 16.607 13.8614 16.607Z"
      fill="currentColor"
    />
  </svg>
))
